import { Table } from "antd";
import React from "react";
import { getFullName } from "../../../careprovider/visits/utils";
import VolunteerTableActions from "./VolunteerTableActions";

const VolunteerTable = ({ opportunities, setOpportunities, carePlan, setCarePlan }) => {
  const columns = [
    {
      title: "Volunteer",
      key: "volunteer",
      render: (_, { workforce }) =>
        workforce.name
          ? workforce?.name
          : getFullName(workforce.givenName, workforce.familyName),
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "opportunityStatus",
    },

    {
      title: "Action",
      key: "action",
      render: (_, opportunity) => (
        <VolunteerTableActions
          opportunity={opportunity}
          opportunities={opportunities}
          setOpportunities={setOpportunities}
          carePlan={carePlan}
          setCarePlan={setCarePlan}
        />
      ),
    },
  ];

  return (
    <>
      <span>Volunteers</span>
      <Table
        className="tableStyling"
        columns={columns}
        dataSource={opportunities.filter(
          (item) => item.opportunityStatus !== "Unassigned"
        )}
        pagination={false}
      />
    </>
  );
};

export default VolunteerTable;
